
import './App.css';
import Filter_column from './components/filter_column';
import Left_column from './components/left_column';

function App() {
  return (
    <div className="App">
     <Left_column/>
     <Filter_column/>
    </div>
    
  );
}

export default App;
